export const environment = {
  production: true,
  apiUrl: 'https://ccgapi.azurewebsites.net',
  firebase: {
    apiKey: "AIzaSyCpW-oXhcL2yjkj_Q-_b9mqtRKgoVw2G70",
    authDomain: "courbensaule-chargen.firebaseapp.com",
    projectId: "courbensaule-chargen",
    storageBucket: "courbensaule-chargen.appspot.com",
    messagingSenderId: "775558186475",
    appId: "1:775558186475:web:23995f472e5757153285ae",
    measurementId: "G-3ZGHZYTPQK"
  }
};
